        
          var SR = {};
          var body = jQuery('body');
          SR.ajaxurl = 'https://www.tolucacultural.com/wp-admin/admin-ajax.php';
          jQuery(document).ready(function ($) {
            $.ajaxSetup({cache: true});
            $.getScript('//connect.facebook.net/es_LA/sdk.js', function () {
              FB.init({
                appId: '460316174170927',
                status: true,
                cookie: true,
                xfbml: true,
                version: 'v3.1',
              });
              $("#tc-fb-connect").removeClass('disabled');
              $("#tc-fb-permissions").removeClass('disabled');
				            });

            /**
             * Send FB user data via ajax
             * @param response object FB.api result
             */
            SR.login_connect = function (response) {
              var data = {action: 'login_connect', token: response.authResponse.accessToken};
              // console.log(data);
              // console.log(response);
              $.post(SR.ajaxurl, data, function (res) {
                // console.log(res);
                //self.location = window.location;
                //window.location.reload(true);
                //window.location.href = window.location.href;

                if (res.action === "register") {
                  self.location = "https://www.tolucacultural.com";
                } else if (res.action === "error") {
                  alert('FB Login failed: ' + res.message);
                } else if (res.action !== "none"){
                  window.location.reload(true);
                }
              }, 'json');
            };
            
            SR.connect_scope = "email";
            
            /**
             * FB Connect Button
             * @param ver int versions of the fb connect
             */
            SR.fb_connect = function (ver) {
              if (undefined === ver)
                ver = '';
              $("#tc-fb-connect" + ver).on("click", function () {
                $(".tc-fb-connect").addClass('fa-spin');
                FB.getLoginStatus(function (response) {
                  if (response.status === 'connected') {
                    SR.login_connect(response);
                  } else {
                    FB.login(function (response) {
                      if (response.status === 'connected') {
                        SR.login_connect(response);
                      } else {
                        $(".tc-fb-connect").removeClass('fa-spin');
                        alert('Fallo en el inicio de sesión');
                      }
                    }, {scope: SR.connect_scope});
                  }
                });
              });
            };

            SR.fb_permissions = function () {
              //$("#tc-fb-permissions").on("click", function () {
              //  FB.login(function (response) {
              //    if (response.status === 'connected') {
              //      console.log(response);
              //      SR.login_connect(response);
              //    } else {
              //      $(".tc-fb-connect").removeClass('fa-spin');
              //      alert('//');
              //    }
              //  }, {scope: SR.connect_scope, auth_type: 'rerequest'});
              //});
            };

            SR.modal_registro = function () {
              //cargar contenido del modal
              $('#registro').on('show.bs.modal', function () {
                var url = SR.ajaxurl + '?action=show_login';
                $.ajaxSetup({cache: true});
                $.get(url, function (response) {
                  $("#modal-registro").html(response);
                  $("#login-redirect").val(window.location);
                  $('#login-email').focus();
                  $('form#entrar').submit(function (event) {
                    event.preventDefault();
                    var modal_registro = $("#modal-registro");
                    var shade = $(".shade");
                    var md_width = modal_registro.width();
                    var md_height = modal_registro.height();
                    shade.css("width", md_width);
                    shade.css("height", md_height);
                    shade.css("display", "block");
                    shade.animate({opacity: "0.7"});
                    $(".shade-inner").css("height", md_height);
                    var str = $(this).serializeArray();
                    var data = {action: 'tc_login', login_data: str};
                    $.post(SR.ajaxurl, data, function (res) {
                      //TODO ajax referer
                      if (res.error !== undefined) {
                        shade.animate({opacity: "0"});
                        shade.css("height", "0px");
                        $(".shade-inner").css("height", "0px");
                        $("#login-error").html(res.error);
                      }
                      if (res.success !== undefined) {
                        window.location.reload();
                      }
                    }, 'json');
                    return false;
                  });
                  SR.fb_connect(2);
                }, 'html');
              });
            };

            

            if (!body.hasClass('logged-in'))
              SR.modal_registro();

            if (body.hasClass('page-template-template-control')) {
              SR.fb_connect();
              SR.fb_permissions();
            }


          });
        
		